export class MismatchedMetadataFlavorError extends Error {
    constructor(expected) {
        super(`Received the wrong flavor of metadata, expected ${expected || "unknown"}`);
    }
}
export class IncorrectConverterError extends Error {
}
//# sourceMappingURL=errors.js.map